import React from "react";
import HeroBanner from "./HomeComponents/HeroBanner";
import Section2 from "./HomeComponents/Section2";
import Section3 from "./HomeComponents/Section3";
import Section4 from "./HomeComponents/Section4";
import Section5 from "./HomeComponents/Section5";
import HomeBannerMobile from "./HomeBannerMobile";

export default function Home() {
  return (
    <div>
      { window.innerWidth > 600 ? <HeroBanner /> : <HomeBannerMobile /> }
      <Section2 />
      <Section5 />
      <Section4 />
      <Section3 />
    </div>
  );
}
